/**
 * Created by mac on 12/23/20
 */

const CollectibleView = function (collectible, unitView) {
    this.collectible = collectible;
    this.unitView = unitView;

    if (collectible.unit.getData().collectible.prizeView || (collectible.unit.isUnmergeable() && cleverapps.skins.getSlot("hasGrabInfoView"))) {
        this.createPrizeView();
    }
};

CollectibleView.prototype.createPrizeView = function () {
    const options = {
        onClick: this.collectible.collect.bind(this.collectible),
        unit: this.collectible.unit
    };
    const prizeView = cleverapps.skins.getSlot("hasGrabInfoView") ? new GrabInfoView(options) : new PrizeView({ }, options);
    prizeView.setAlignment(this.unitView.width / 2, this.unitView.height);
    this.unitView.createAdditionalView("free", prizeView);
};

CollectibleView.prototype.feedAnimation = function (targetView, callback) {
    this.clearAnimations();

    const styles = cleverapps.styles.CollectibleView.feedAnimation;
    const movingNode = cleverapps.Scenes.GetMovingNode(targetView);

    const localPosition = cc.p(0.3 * targetView.width, 0.6 * targetView.height);
    const targetPosition = movingNode.convertToNodeSpace(targetView.convertToWorldSpace(localPosition));

    const distance = cc.pDistance(targetView, this.unitView);
    const duration = Math.max(0.5, distance / styles.speed);

    this.feedingAction = this.unitView.runAction(
        new cc.Sequence(
            new cc.ReplaceParent(movingNode),
            new cc.Spawn(
                new cc.JumpAnimation(
                    duration,
                    this.unitView,
                    cc.pSub(targetPosition, this.unitView),
                    styles.jumpHeight
                ),
                new cc.ScaleTo(duration, 0.6).easing(cc.easeBackIn())
            ),
            new cc.RemoveSelf()
        )
    ).setFinalize(callback);
};

CollectibleView.prototype.clearAnimations = function () {
    if (this.feedingAction && !this.feedingAction.isDone()) {
        this.unitView.stopAction(this.feedingAction);
        delete this.feedingAction;
    }
};

CollectibleView.prototype.collectionAnimation = function (index, callback) {
    let target;
    let effect;

    switch (this.collectible.unit.getType()) {
        case "fruit":
            target = "harvested";
            effect = "merge.fruit_fly.finish";
            break;
    }

    if (target) {
        target = cleverapps.aims.getTarget(target);
    }

    const actions = [];

    actions.push(new cc.Show());
    actions.push(StandartAnimations.animateCollect(this.unitView, target, {
        path: true,
        adjustToTarget: true,
        collectEffect: true,
        effect
    }));

    actions.push(new cc.Hide());
    actions.push(new cc.CallFunc(callback));
    actions.push(new cc.RemoveSelf());

    this.unitView.stopAllActions();
    this.unitView.runAction(new cc.Sequence(actions));
};

cleverapps.styles.CollectibleView = {
    feedAnimation: {
        speed: 1500,
        jumpHeight: 240
    }
};
